import {
  CounterpartyGroupSortOption,
  enumCounterpartyGroupSortOption,
  OperationType,
} from '@rematter/frontend-lib-api-client';
import { DataGridSelection } from '@rematter/ui-web';
import { atom } from 'jotai';

import { counterpartyGroupDeleteAtom } from '../_graphql/mutationCounterpartyGroupCrud';
import { counterpartyGroupsListQueryAtom } from '../_graphql/queryCounterpartyGroupsList';
import { CounterpartyGroupRecord } from '../types/pricing';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('cgq');
export const $limit = atomFromQueryString.number('cglimit', 50);
export const $offset = atomFromQueryString.number('cgoffset', 0);
export const $selectedOperationType = atomFromQueryString.string('cgOpType');

export const $selectedKeys = atom<DataGridSelection>(new Set<React.Key>());
export const $isCreateDialogOpen = atom<boolean>(false);
export const $selectedCounterpartyGroup = atom<CounterpartyGroupRecord | null>(
  null,
);
export const $currentSorting = atom<CounterpartyGroupSortOption[]>([
  enumCounterpartyGroupSortOption.NameAsc,
]);

export const $remoteCounterpartyGroups = counterpartyGroupsListQueryAtom(
  (get) => {
    const searchTerm = get($searchTerm);
    const limit = get($limit);
    const offset = get($offset);
    const sorting = get($currentSorting);
    const operationType = get($selectedOperationType);

    return {
      variables: {
        searchTerm: searchTerm || undefined,
        operationTypes: operationType
          ? [operationType as OperationType]
          : undefined,
        limit,
        offset,
        sorting,
      },
    };
  },
);

export const $deleteCounterpartyGroup = counterpartyGroupDeleteAtom({
  onSuccess: (get) => {
    get($remoteCounterpartyGroups).refetch?.();
  },
});
